import React from 'react';
import { Link } from 'react-router-dom';

export function CalendarIcon({ className = '', size = 18 }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 3.25a.75.75 0 0 1 .75.75v1h8.5V4a.75.75 0 0 1 1.5 0v1H19a2.75 2.75 0 0 1 2.75 2.75V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V7.75A2.75 2.75 0 0 1 5 5h1.25V4A.75.75 0 0 1 7 3.25ZM3.75 10v9c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-9H3.75ZM5 6.5c-.69 0-1.25.56-1.25 1.25V8.5h16.5v-.75c0-.69-.56-1.25-1.25-1.25H5Zm2.25 6.25h2v2h-2v-2Zm3.75 0h2v2h-2v-2Zm3.75 0h2v2h-2v-2Zm-7.5 3.75h2v2h-2v-2Zm3.75 0h2v2h-2v-2Z" />
    </svg>
  );
}

function calendarButtonClassName({
  className = '',
  compact = false,
  iconOnly = false,
  collapseLabel = false,
}) {
  return [
    'calendar-button',
    compact ? 'calendar-button--compact' : '',
    iconOnly ? 'calendar-button--icon-only' : '',
    collapseLabel ? 'calendar-button--collapse-label' : '',
    className,
  ].filter(Boolean).join(' ');
}

export function CalendarButton({
  children = 'Calendar',
  className = '',
  compact = false,
  iconOnly = false,
  collapseLabel = false,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={calendarButtonClassName({ className, compact, iconOnly, collapseLabel })}
      {...props}
    >
      <CalendarIcon className="calendar-button__icon" />
      {!iconOnly && <span className="calendar-button__label">{children}</span>}
    </button>
  );
}

export function CalendarLink({
  children = 'Calendar',
  className = '',
  compact = false,
  iconOnly = false,
  collapseLabel = false,
  ...props
}) {
  return (
    <Link
      className={calendarButtonClassName({ className, compact, iconOnly, collapseLabel })}
      {...props}
    >
      <CalendarIcon className="calendar-button__icon" />
      {!iconOnly && <span className="calendar-button__label">{children}</span>}
    </Link>
  );
}
